import React, { useEffect } from "react";
import "../pages/PurchaseOrders.css";
import "./NoteModal.css";

interface NoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  note: string;
  orderCode?: string;
  modelName?: string;
}

const closeIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
);

/** Sipariş notunu salt okunur gösterir (po-modal). Esc / dışarı tıklama / Kapat ile kapanır. */
const NoteModal: React.FC<NoteModalProps> = ({ isOpen, onClose, note, orderCode, modelName }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") { e.stopPropagation(); onClose(); }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sub = [orderCode, modelName].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(" · ");

  return (
    <div className="po-overlay center" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="po-modal nm-modal" role="dialog" aria-modal="true" aria-labelledby="nm-title">
        <div className="po-modal-head">
          <div>
            {sub && <span className="po-kicker">{sub}</span>}
            <h3 id="nm-title">Sipariş notu</h3>
          </div>
          <button type="button" className="po-ib big" aria-label="Kapat" onClick={onClose}>{closeIcon}</button>
        </div>
        <div className="po-modal-body">
          <div className="nm-text">{note}</div>
        </div>
        <div className="po-modal-foot">
          <button type="button" className="po-btn primary" onClick={onClose} autoFocus>Kapat</button>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
